module.exports = __webpack_public_path__ + "img/light-bulb.4600f265.png";